import { useQuery } from "react-query";
import { getClientDocumentById } from "api/customers";

/**
 * Hook to fetch a document row by its ID.
 *
 * @param {string|number} id - The document ID to fetch.
 * @param {object} options - Optional react-query config overrides.
 * @returns {object} - The query result containing data, status, error, etc.
 */
export const useGetDocumentById = (id, options = {}) => {
  return useQuery(
    ["document", id],
    () => getClientDocumentById(id).then((res) => res?.data?.document),
    {
      enabled: !!id,
      ...options,
    }
  );
};
